export default __webpack_public_path__ + "images/VC.8446a0c.png";